import { TwoFactorLoginStage, TwoFactorSetupStage } from '@oneview/constants/lookups';
import { UmaOption, UmaUserSerializer } from '@orbis-systems/orbis-api-clients/uma';
import { createAction } from '@reduxjs/toolkit';

export const loginTimeout = createAction('LoginTimeout');

export const setTermsOfUseSigned = createAction<boolean>('SetTermsOfUseSigned');

export const set2faSetupStage = createAction<TwoFactorSetupStage>('Set2FaSetupStage');

export const set2faStage = createAction<TwoFactorLoginStage>('Set2FaStage');

export const setAvailable2faOptions = createAction<Partial<UmaOption>[]>('SetAvailable2FaOptions');

export const setUmaUser = createAction<UmaUserSerializer>('SetUmaUser');

export const setEmailVerificationNeeded = createAction<boolean>('SetEmailVerificationNeeded');

export const setPhoneVerificationNeeded = createAction<boolean>('SetPhoneVerificationNeeded');
